import { observer } from "mobx-react";
import React from "react";
import adminStore from "../../stores/adminStore";
import { FinishedPolls } from "./FinishedPolls";
import { TimesDistribution } from "./TimesDistribution";
import { AppBar, Tabs, Tab } from "@material-ui/core";
import { ResultScore } from "./ResultScore"

import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Users } from "../Users";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};


@observer
class Charts extends React.Component {
    constructor(props) {
        super(props)
        this.state = { tab: 0 }
    }

    tabProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        }
    }

    render() {
        const { dashboard } = adminStore
        const { tab } = this.state

        const {mean_response_time} = dashboard
        if (!mean_response_time) return null
        const avg = mean_response_time['avg'] > 60
            ? (mean_response_time['avg'] / 60).toFixed(2) + ' min'
            : mean_response_time['avg'].toFixed(2) + ' seg'
        const min = mean_response_time['min'] > 60
            ? (mean_response_time['min'] / 60).toFixed(2) + ' min'
            : mean_response_time['min'].toFixed(2) + ' seg'
        const max = mean_response_time['max'] > 60
            ? (mean_response_time['max'] / 60).toFixed(2) + ' min'
            : mean_response_time['max'].toFixed(2) + ' seg'

        return (
            <div style={{
                marginTop: "-32px",
                marginLeft: "-24px",
                marginRight: "-24px"
            }}>
                <AppBar position="static" style={{backgroundColor: "#3c474a", color: "#fff"}}>
                    <Tabs value={tab} onChange={(e, v) => { this.setState({tab: v}); } }>
                        <Tab label="Tiempo de Respuesta" {...this.tabProps(0)} />
                        <Tab label="Informe de Uso" {...this.tabProps(1)} />
                        <Tab label="Resultados" {...this.tabProps(2)} />
                        <Tab label="Publico" {...this.tabProps(3)} />
                    </Tabs>
                </AppBar>

                <TabPanel value={tab} index={0}>
                    <h1>
                        Tiempo Promedio:
                        <b>{' '}{avg}{' '}</b>
                        <br />
                        <span style={{fontSize: "0.5em"}}>
                            {`Minimo: ${min}`}
                            <br />
                            {`Maximo: ${max}`}
                        </span>
                    </h1>
                    <br />
                    <div>
                        <h2> Horarios de Respuesta </h2>
                        <TimesDistribution />
                    </div>
                </TabPanel>

                <TabPanel value={tab} index={1}>
                    <FinishedPolls />
                </TabPanel>

                <TabPanel value={tab} index={2}>
                    <ResultScore />
                </TabPanel>

                <TabPanel value={tab} index={3}>
                    <Users />
                </TabPanel>
            </div>
        )
    }
}

export { Charts as default };

